<template>
	<div class="tabs-form">
		<div class="tabs">
			<div
				v-for="item in identity"
				:key="item.id"
				@click="handlePrivateClick(item.id)"
				:class="['tabs-pane', tabId == item.id && 'tabs-pane-avtive']"
			>
				{{ item.name }}
			</div>
		</div>

		<el-form :inline="true" class="form" ref="form" :model="form">
			<div class="form-contain">
				<el-form-item prop="fu_title">
          <InputTopTip v-model="form.fu_title" placeholder="曲式名称">
            <el-input
              v-model="form.fu_title"
              size="small"
              class="width-264"
              placeholder=""
              @keyup.native.enter=";(page = 1), getMusicalSampleList()"
            ></el-input>
          </InputTopTip>
				</el-form-item>
        <el-form-item prop="name">
          <InputTopTip v-model="form.name" placeholder="创建人">
            <el-input
              v-model="form.name"
              size="small"
              class="width-264"
              placeholder=""
              @keyup.native.enter=";(page = 1), getMusicalSampleList()"
            ></el-input>
          </InputTopTip>
				</el-form-item>
			</div>

			<el-form-item class="form-reset">
				<el-button
					type="primary"
					@click=";(page = 1), getMusicalSampleList()"
					size="small"
					class="action-btn"
					style="width: 70px; margin-right: 15px;"
					>搜索</el-button
				>
				<el-button @click="resetForm('form')" size="small" style="width: 70px;">重置</el-button>
			</el-form-item>
		</el-form>

		<div class="table">
			<div class="table-header">
				<div _flex="~">
					<el-button
						type="primary"
						@click="newParamsEvent"
						size="small"
						v-if="
              ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
              ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId == 5) ||
              ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && tabId == 2) ||
              ($store.state.user.userInfo.type === $api.account.types.OTHER.value && tabId == 1 && $permissions([`SP56003`]))
            "
					>
						<i class="el-icon-plus" style="margin-right: 7px;"></i>新建
					</el-button>
				</div>

				<el-button
					v-if="
						(($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
            ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId == 5) ||
            ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && tabId == 2)) &&
						multipleSelection.length >= 1
					"
					@click="deleteFileStorageAll"
					size="small"
					:disabled="multipleSelection.length <= 0"
					:style="multipleSelection.length <= 0 && 'color: #4b4b4b !important;background: #9f9f9f !important'"
				>
					<i class="el-icon-delete" style="margin-right: 7px;"></i>批量删除
				</el-button>
			</div>

			<el-table
				:data="tableData"
				stripe
				style="width: 100%; min-height: 570px;"
				@selection-change="handleSelectionChange"
				ref="multipleTable"
			>
				<el-table-column
					type="selection"
					width="55"
					align="center"
					v-if="
            ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
            ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId == 5) ||
            ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && tabId == 2)
          "
				></el-table-column>
        <el-table-column label="曲式名称" :show-overflow-tooltip="true" prop="title"></el-table-column>
        <el-table-column label="创建人" :show-overflow-tooltip="true" prop="account.realname"></el-table-column>
        <el-table-column label="时间" :show-overflow-tooltip="true" prop="created_at"></el-table-column>
        <el-table-column :key="'同步状态'" align="left" label="同步状态">
					<template slot-scope="scope">
						<div style="display: flex; justify-content: left; align-items: center;">
							<span slot="reference" v-show="scope.row.extra.length > 0" style="margin-right: 5px;">
								<i class="dotClass" style="background-color: #67c23a;"></i>
							</span>
							<span slot="reference" v-show="scope.row.extra.length == 0" style="margin-right: 5px;">
								<i class="dotClass" style="background-color: #b81a19;"></i>
							</span>
							{{ scope.row.extra.length == 0 ? '未同步' : '已同步' }}
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" >
					<template slot-scope="{ row }">
						<div style="display: flex; justify-content: center;">
							<el-tooltip
                placement="top"
                effect="light"
                v-if="
                  ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value) ||
                  ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value) ||
                  ($store.state.user.userInfo.type === $api.account.types.TEACHER.value) ||
                  ($store.state.user.userInfo.type === $api.account.types.SCHOOL_ADMIN.value) ||
                  ($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([`SP56002`]))
                "
              >
								<div slot="content">查看</div>
								<div
									class="icon-circle"
									style="background: white;"
									_border="1px solid [#ebeef5]"
									@click="routePush(row)"
								>
									<i class="el-icon-view" style="color: #ff7143;"></i>
								</div>
							</el-tooltip>
							<el-tooltip
								placement="top"
								effect="light"
								v-if="
                  ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
                  ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && row.is_owner) ||
                  ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && row.is_owner) ||
                  ($store.state.user.userInfo.type === $api.account.types.OTHER.value && tabId == 1 && $permissions([`SP56004`]))
                "
							>
								<div slot="content">编辑</div>
								<div
									class="icon-circle"
									style="color: #3f6af7; background: white;"
									_border="1px solid [#ebeef5]"
									@click=";(scopeType = 'edit'), editParamsEvent(row)"
								>
									<svg class="icon" aria-hidden="true">
										<use xlink:href="#icon-iconoutlinesetting"></use>
									</svg>
									<!-- <i class="el-icon-edit-outline" style="color: #3f6af7;"></i> -->
								</div>
							</el-tooltip>

							<el-tooltip
								placement="top"
								effect="light"
								v-if="
                  ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
                  ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && row.is_owner) ||
                  ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && row.is_owner) ||
                  ($store.state.user.userInfo.type === $api.account.types.OTHER.value && tabId == 1 && $permissions([`SP56005`]))
								"
							>
								<div slot="content">删除</div>
								<div class="icon-circle" @click="deleteParamsEvent(row)">
									<!-- <i class="el-icon-delete" style="color: #ff1f1f;"></i> -->
									<svg
										class="icon"
										aria-hidden="true"
										style="width: 100%; height: 100%; outline: none; box-shadow: none;"
									>
										<use xlink:href="#icon-deltred"></use>
									</svg>
								</div>
							</el-tooltip>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination">
				<div>总计：{{ total }}条/{{ last_page }}页</div>
				<el-pagination
					:current-page.sync="page"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="page_size"
					:total="total"
					background
					layout="prev, pager, next, jumper, sizes, slot"
					@current-change="handleCurrentChange"
					@size-change="handleSizeChange"
          :key="`${paginationKey}_${tabId}`"
				>
				</el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
import { mapValues } from 'lodash'
import {
  adminIdentity,
  teacherIdentity,
  schoolIdentity,
  researchIdentity
} from './const.js'
export default {
	data() {
		return {
      adminIdentity,
      teacherIdentity,
      schoolIdentity,
      researchIdentity,
      identity: [],
			form: {
				fu_title: '',
				name: '',
			},
			page: 1,
			page_size: 10,
			last_page: '',
			total: 0,
			tabId: 1,
			tableData: [],
			multipleSelection: [],
			row: {},
      paginationKey: new Date().getTime(),
      jumpUrl: '',
      token: ''
		}
	},
	async created() {
    this.initPage()
	},
  watch: {
	},
	methods: {
    handlePrivateClick(e) {
      this.getSearchParams(e)
      this.getMusicalSampleList()
    },
		async initPage() {
      this.jumpUrl = `${window.web_config.api_url}${window.web_config.musical_form_path}`
      this.token = JSON.parse(window.localStorage.getItem('tokenInfo')).access_token
      const userInfo = this.$store.state.user.userInfo
      if (userInfo.type === this.$api.account.types.SCHOOL_ADMIN.value) {
				this.identity = this.schoolIdentity
			} else if (userInfo.type === this.$api.account.types.TEACHER.value) {
				this.identity = this.teacherIdentity
			} else if (userInfo.type === this.$api.account.types.PLATFORM_ADMIN.value) {
				this.identity = this.adminIdentity
			} else if (userInfo.type === this.$api.account.types.RESEARCH.value) {
        this.identity = this.researchIdentity
      } else {
				this.identity = this.adminIdentity
			}
      this.getSearchParams()
      this.getMusicalSampleList()
		},
    async getSearchParams(top = undefined) {
      this.vModelChangeVisible = true
      const searchParams = this.$store.state.searchParams[`${this.$route.name}`]
      if (top != undefined) {
        this.tabId = top
        this.page = searchParams[top]?.page || 1
        this.page_size = searchParams[top]?.page_size || 10
        this.form.fu_title = searchParams[top]?.fu_title
        this.form.name =  searchParams[top]?.name
      } else {
        try {
          const { historyTop } = searchParams
          this.tabId = historyTop
          this.page = searchParams[historyTop]?.page || 1
          this.page_size = searchParams[historyTop]?.page_size || 10
          this.form.fu_title = searchParams[historyTop]?.fu_title
          this.form.name = searchParams[historyTop]?.name
        } catch(err) {
          console.log('正常~')
          this.tabId = this.identity[0]?.id
          this.page = 1
          this.page_size = 10
        }
      }
      this.paginationKey = new Date().getTime()
    },
		async editParamsEvent(row) {
			this.row = row
      let uri = `${this.jumpUrl}?type=editor&id=${row.id}&token=${this.token}`
      window.open(`${uri}`)
		},
    newParamsEvent() {
      let uri = `${this.jumpUrl}?type=new&token=${this.token}`
      window.open(`${uri}`)
    },
		async getMusicalSampleList() {
      const params = {
				...this.form,
				scope_type: this.tabId,
				page_size: this.page_size,
				page: this.page
			}
      this.$store.commit('setTabSearchParams', { key: `${this.$route.name}`, top: this.tabId, params: params })
			const data = await this.$api.musical_sample.getMusicalSampleList(params)
			this.tableData = data.data
			this.total = data.meta.total
			this.last_page = data.meta.last_page
		},
		async deleteFileStorageAll() {
			if (this.multipleSelection.length <= 0) return
			this.$confirm('此操作将永久删除, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(async () => {
					const params = this.multipleSelection.map(item => {
						return item.id
					})
					await this.$api.musical_sample.deleteMusicalSampleList({
						ids: params
					})
					this.page = 1
					this.getMusicalSampleList()
				})
				.catch(() => {})
		},
		async twoConfirmClick() {
			const data = await this.$api.musical_sample.deleteMusicalSample(this.row.id)
			if (data.success) {
				// 因为存在那种勾选但是还是点击删除的情况，需要手动删掉
				const index = this.multipleSelection.findIndex(item => item.id === this.row.id)
				this.multipleSelection.splice(index, 1)
				this.getMusicalSampleList()
			} else {
				console.log('error')
			}
		},
		deleteParamsEvent(row) {
			this.row = row
			this.$confirm('此操作将永久删除, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				await this.twoConfirmClick()
			})
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		handleTabClick(e) {
			this.getSearchParams(e)
			this.getMusicalSampleList()
		},
		resetForm(formName) {
			this.$refs[formName].resetFields()
      this.form = mapValues(this.form, () => '')
			this.getMusicalSampleList()
		},
		routePush(row) {
      window.localStorage.setItem('musicalView', JSON.stringify(row))
			this.$router.push({
        name: 'musicalManagementView',
				query: {
					id: row.id
				}
			})
		},
		// 更改条数
		handleSizeChange(val) {
			this.page = 1
			this.page_size = val
			this.getMusicalSampleList()
		},
		// 更改页码
		handleCurrentChange(val) {
			this.page = val
			this.getMusicalSampleList()
		},
	},
	computed: {
	}
}
</script>
<style scoped lang="scss">
.action-btn:focus {
	background-color: #ff5e2a;
	border-color: #ff5e2a;
	opacity: 1 !important;
}
.tabs-form {
	min-height: 102px;
	border-radius: 8px 8px 8px 8px;
	opacity: 1;
}
.table {
	margin-top: 10px;
	padding: 20px;
	background: #ffffff;
	display: block;
}
/deep/ .el-table tbody tr td:last-child {
	padding-right: 0 !important;
}
.table-button {
	margin: 0;
}

.scope-dialog {
	/deep/ .el-dialog .el-dialog__header {
		padding-bottom: 0px;
	}
	.scope-file {
		display: flex;
		flex-wrap: wrap;
		width: 50px;
		img {
			width: 50px;
			object-fit: contain;
		}
	}
	.scope-file-2 {
		display: flex;
		flex-wrap: wrap;
		width: 150px;
		img {
			width: 150px;
			object-fit: contain;
		}
	}
}

.video-dialog {
	margin-top: 25vh;
}
.pagination {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 26px;
}
.icon-circle {
	width: 28px;
	height: 28px;
	border-radius: 100%;
	background: #fff8f5;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}
.icon-circle:nth-child(2) {
	margin-left: 15px;
	margin-right: 15px;
}
.table-header {
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
}
.tabs {
	display: flex;
	align-items: center;
	border-bottom: 1px solid #eeeeee;
	height: 39px;
	background: #ffffff;
}
.tabs-pane-avtive {
	color: #4a4a4a !important;
	position: relative;
}
.tabs-pane-avtive::after {
	content: '';
	display: block;
	position: absolute;
	top: 38px;
	width: 43px;
	height: 2px;
	background: #ff5e2a;
	border-radius: 0px 0px 0px 0px;
}
.tabs-pane {
	margin-left: 17px;
	margin-right: 8px;
	width: 36px;
	height: 39px;
	font-size: 18px;
	font-family: PingFang SC-Bold, PingFang SC;
	font-weight: bold;
	color: #bbbbbb;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}
.form {
	padding: 15px 0px 0px 19px !important;
	display: flex;
	justify-content: space-between;
	min-height: 40px;
	background: #ffffff;
}
.form-contain {
	flex-basis: 80%;
	/deep/ .el-form-item {
		margin-bottom: 12px;
	}
}
.form-reset {
	display: flex;
	flex-wrap: nowrap;
  /deep/ .el-form-item__content {
    white-space: nowrap;
  }
}
.width-166 {
	width: 166px;
}
.width-264 {
	width: 264px;
}

.dotClass {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	display: block;
}
// 少婷提的——表格80
/deep/.el-table thead th {
	background-color: #fafafa;
	border-top: 1px solid #fff;
}
</style>
